import { takeLatest, put, select } from 'redux-saga/effects';

import {
  types as orderActionTypes,
  selectors as orderSelectors,
} from 'state/order';

import { types as shipmentActionTypes } from 'state/shipments';
import { types as loadActionTypes } from 'state/loads';
import { actions as editLogActions } from 'state/editLog';

function* handleSetLog({ type, payload }) {
  const isEditing = yield select(orderSelectors.getIsEditing);
  if (isEditing) {
    yield put(editLogActions.setLog({ log: { type, payload } }));
  }
}

export default function* () {
  yield takeLatest(orderActionTypes.setExtra$, handleSetLog);

  yield takeLatest(shipmentActionTypes.CHANGE_VALUES, handleSetLog);
  yield takeLatest(shipmentActionTypes.SET_EXTRA, handleSetLog);
  yield takeLatest(
    shipmentActionTypes.SET_COMMENT_FOR_TRANSPORTIST,
    handleSetLog
  );
  yield takeLatest(shipmentActionTypes.SET_INTERNAL_REFERENCE, handleSetLog);
  yield takeLatest(shipmentActionTypes.ADD_SHIPMENT, handleSetLog);
  yield takeLatest(shipmentActionTypes.REMOVE_SHIPMENT, handleSetLog);

  yield takeLatest(loadActionTypes.CHANGE_LOAD_VALUES, handleSetLog);
  yield takeLatest(loadActionTypes.ADD_LOAD, handleSetLog);
  yield takeLatest(loadActionTypes.REMOVE_LOAD, handleSetLog);
}

export { handleSetLog };
